import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Ecosystem from "@/pages/Ecosystem";

export const Route = createFileRoute("/es/sobre-qbd/ecosistema")({
  head: () => buildRouteHead("/es/sobre-qbd/ecosistema"),
  component: Ecosystem,
});

